export const TABLE_EVENTS = {
  scroll: 'scroll',
  rowExpand: 'row-expand',
  changeSize: 'change-size',
  rowDblclick: 'row-dblclick'
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/config/events.js